
import { defineComponent } from 'vue'
import { useFormModule } from '@/modules/_shared/forms'

export default defineComponent({
    name: 'employee-form-field-last-name',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String
        }
    },
    setup () {
        const { validations: { requiredRule } } = useFormModule()
        return {
            requiredRule
        }
    }
})
